import { UserExperienceDto } from '@apply/api/src/api/ApplyApi';
import { ExperienceProjectType, ExperienceType, ExperienceVerificationStatusType } from '@apply/constants';

export interface ProvidedGuidanceMessageProps {
    unverifiedExperience: UserExperienceDto[];
    verifiedExperience: UserExperienceDto[];
}

export const ProvidedGuidanceMessage: React.FC<ProvidedGuidanceMessageProps> = ({ unverifiedExperience, verifiedExperience }) => {
    const projectsProvided = () => {
        let projectCount = 0;

        //Unverified
        projectCount = unverifiedExperience.filter(
            (e) =>
                e.experienceTypeId == ExperienceType.NonBfi &&
                e.verificationStatusTypeId != ExperienceVerificationStatusType.Rejected &&
                e.verificationStatusTypeId != ExperienceVerificationStatusType.UnableToVerify &&
                e.projectTypeId != ExperienceProjectType.PersonalResidence
        ).length;

        //Verified
        projectCount =
            projectCount +
            verifiedExperience.filter(
                (e) =>
                    e.experienceTypeId == ExperienceType.NonBfi &&
                    e.verificationStatusTypeId != ExperienceVerificationStatusType.Rejected &&
                    e.verificationStatusTypeId != ExperienceVerificationStatusType.UnableToVerify &&
                    e.projectTypeId != ExperienceProjectType.PersonalResidence
            ).length;

        return projectCount;
    };

    const renderText = () => {
        const numberOfProjects = projectsProvided();
        if (numberOfProjects == 0) {
            return <span>You have not provided any projects, most applicants provide 20.</span>;
        } else if (numberOfProjects == 1) {
            return <span>You have provided 1 project, most applicants provide 20.</span>;
        } else {
            return <span>You have provided {numberOfProjects} projects, most applicants provide 20.</span>;
        }
    };

    return (
        <>
            <div>{renderText()}</div>
        </>
    );
};
